/* Footer Grid: fit the wordmark SVG viewBox to the real glyph box so the logotype
   is uniformly scaled (undistorted), fully visible, and never clipped, for any shop
   name. The section height is reserved via --modulo-fgr-wm-h, so this only refines
   the horizontal fit → no vertical CLS. */
(function () {
  'use strict';
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  function fit(svg) {
    var t = svg.querySelector('text');
    if (!t || typeof t.getBBox !== 'function') return;
    try {
      var bb = t.getBBox();
      if (bb && bb.width > 0 && bb.height > 0) {
        svg.setAttribute('viewBox', (bb.x - 2) + ' ' + (bb.y - 2) + ' ' + (bb.width + 4) + ' ' + (bb.height + 4));
      }
    } catch (e) { /* getBBox can throw if not rendered yet, ignore */ }
  }

  function run(root) {
    var els = (root || document).querySelectorAll('.modulo-fgr__wm');
    for (var i = 0; i < els.length; i++) fit(els[i]);
  }

  function boot() {
    run(document);
    // Web/theme fonts change glyph metrics, so refit once they're ready.
    if (document.fonts && document.fonts.ready && typeof document.fonts.ready.then === 'function') {
      document.fonts.ready.then(function () { run(document); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor re-renders a section into e.target, so refit just that subtree.
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();
